import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiDeleteAccreditationRequest extends ApiRequestor {
  async $deleteAccreditation(accreditationId, organizationId) {
    const payload = {accreditationId,organizationId};
    return this.$http('DELETE', `accreditationRequests`, {payload});
  }
}
